import styled, { css } from 'styled-components';
import { defaultTheme } from '../../../../utils/defaultTheme';

const flexBoxStyles = (flexDirection, justifyContent) => css`
    display: flex;
    flex-direction: ${flexDirection};
    justify-content: ${justifyContent};
    align-items: center;
`;

export const TooltipWrapper = styled.div`
    ${flexBoxStyles('column', 'center')};
    align-items: flex-start;
    gap: 10px;
    height: 100%;
    width: 200px;
    background-color: #fff;
    padding: 7px 17px 4px;
    position: relative;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    //tooltip arrow
    &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        border-width: 7px;
        border-style: solid;
        border-color: white transparent transparent transparent;
    }
`;
export const TooltipTitleWrapper = styled.div`
    ${flexBoxStyles('row', 'flex-center')};
    gap: 10px;
`;
export const TooltipMainTitleWrapper = styled.div`
    ${flexBoxStyles('row', 'center')};
    column-gap: 5px;
    height: 20px;
`;

export const TooltipLabel = styled.div`
    font-size: 14px;
    font-family: Source Sans Pro, Open Sans;
    color: ${defaultTheme.blue[900]};
    width: fit-content;
    max-width: 120px;
`;
export const TooltipLegend = styled.div`
    width: 8px;
    height: ${props => (props.isMainBrand ? '8px' : '3px')};
    border-radius: ${props => (props.isMainBrand ? '0px' : '2px')};
    background-color: ${props => props.color};
`;
export const TooltipTopBrandsWrapper = styled.div`
    ${flexBoxStyles('row', 'flex-start')};
    align-items: stretch;
    align-content: stretch;
    flex-wrap: wrap;
    width: 100%;
`;
export const TooltipTopBrandsRowWrapper = styled.div`
    ${flexBoxStyles('row', 'space-between')};
    column-gap: 10px;
    width: 100%;
    margin-bottom: 5px;
`;
export const TooltipTopBrandsRow = styled.div`
    ${flexBoxStyles('row', 'flex-start')};

    ${({ isMarketAverage }) =>
        !isMarketAverage &&
        css`
            column-gap: 5px;
        `}
`;
